import { type FC } from 'react';
import { Cell, MiniGridRow, Stub } from '@direct-frontend/components';
import styles from './SettingsBlockRow.module.css';

interface SettingsBlockRowStubProps {
    id: string;
}

export const SettingsBlockRowStub: FC<SettingsBlockRowStubProps> = ({ id }) => (
    <MiniGridRow id={id}>
        <Cell className={styles.header}>
            <Stub width={116} height={20} />
        </Cell>

        <Cell width="full" leftPadding={false}>
            <Stub width={68} height={20} />
        </Cell>

        <Cell type="Icon">
            <Stub width={24} height={24} />
        </Cell>
    </MiniGridRow>
);
